var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('public-frame-dark',{attrs:{"menu":false}},[_c('div',{staticClass:"flex-in-middle page-body"},[_c('div',{staticClass:"text-center"},[_c('h1',{staticStyle:{"font-size":"4rem"}},[_vm._v("403 Unauthorized!")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }